import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiMapPin, FiPhone } = FiIcons;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Experience', href: '#guide' },
    { name: 'Packages', href: '#packages' },
    { name: 'Accommodation', href: '#rooms' },
    { name: 'Location', href: '#location' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass-morphism' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="text-2xl font-bold gradient-text"
          >
            Walawe Park View
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <motion.a
                key={item.name}
                href={item.href}
                whileHover={{ scale: 1.1 }}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
              >
                {item.name}
              </motion.a>
            ))}
          </div>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-6">
            <div className="flex items-center space-x-2 text-white/80">
              <SafeIcon icon={FiMapPin} className="text-lg" />
              <span className="text-sm">232, Dahaiyagala</span>
            </div>
            <motion.a
              href="https://wa.me/94771234567"
              whileHover={{ scale: 1.05 }}
              className="glass-card px-4 py-2 rounded-full text-white font-medium hover:bg-white/10 transition-colors duration-300"
            >
              <SafeIcon icon={FiPhone} className="inline mr-2" />
              WhatsApp
            </motion.a>
          </div>

          {/* Mobile Menu Button */}
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden glass-card p-2 rounded-lg text-white"
          >
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-xl" />
          </motion.button>
        </div>

        {/* Mobile Menu */}
        <motion.div
          initial={false}
          animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
          className="md:hidden overflow-hidden"
        >
          <div className="glass-card rounded-lg p-4 mt-2 space-y-4">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={() => setIsOpen(false)}
                className="block text-white/80 hover:text-white transition-colors duration-300 font-medium"
              >
                {item.name}
              </a>
            ))}
            <div className="pt-4 border-t border-white/20">
              <a
                href="https://wa.me/94771234567"
                className="flex items-center space-x-2 text-white/80 hover:text-white transition-colors duration-300"
              >
                <SafeIcon icon={FiPhone} />
                <span>Contact via WhatsApp</span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.nav>
  );
};

export default Navigation;